import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";
import { QueryTags } from "api/types/QueryTags";
import Title from "api/types/models/title";

const titleEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getTitles: builder.query<Title[], void>({
    query: () => ({
      url: "/titles",
    }),
    keepUnusedDataFor: 300, // 5 minutes
    providesTags: ["Titles"],
  }),
});

export default titleEndpoints;
